<template>
    <div class="ibox float-e-margins fadeInRight">
        <div class="tabbable new-tabs">
            <ul class="nav nav-tabs p-top-6 m-bottom-10" id="myTab">
                <li :class="{ active: activeTab === 'communication' }">
                    <a class="tab-text"  @click="activeTab = 'communication'">Communication</a>
                </li>

                <li :class="{ active: activeTab === 'issues' }">
                    <a class="tab-text"  @click="activeTab = 'issues';hideTabs('tabs-complaint')">Issues ({{totalIssues}})</a>
                </li>

                <li :class="{ active: activeTab === 'activity' }">
                    <a class="tab-text" @click="activeTab = 'activity'">Activity</a>
                </li>
            </ul>
            <div class="tab-content">
                <communication-tabs
                    :itemType="itemType"
                    :complaint-id="complaintId"
                    :itemId="itemId"
                    :bookingId="bookingId"
                    :credentials="credentials"
                    :customer-id="customerId"
                    v-if="activeTab === 'communication'"></communication-tabs>

                <activity-tabs v-if="activeTab === 'activity'"
                               :itemType="itemType"
                               :itemId="itemId"
                               :bookingId="bookingId"
                               :credentials="credentials"
                               :customer-id="customerId"
                >
                </activity-tabs>
                <issues-tab v-show="activeTab === 'issues'"
                            :itemType="itemType"
                            :itemId="itemId"
                            :bookingId="bookingId"
                            :credentials="credentials"
                            :show-view-issues-popup="showViewIssuesPopup"
                            @issuesCountUpdated="totalIssues = $event">

                </issues-tab>
            </div>
        </div>
    </div>
</template>

<script>
import CommunicationTabs from "@/modules/Booking/components/BookingViewTabs/Communication/CommunicationTabs.vue";
import ActivityTabs from "@/modules/Booking/components/BookingViewTabs/Activity/ActivityTabs.vue";
import {object} from "underscore";
import IssuesTab from "@/modules/Booking/components/BookingViewTabs/Issues/IssuesTab.vue";
import {EventBus} from "@/events/event-bus";

export default {
    name: "Tabs",
    components: {IssuesTab, ActivityTabs, CommunicationTabs },
    props :{
      itemType: {
        type: String,
        required: true
      },
      itemId: {
        type: Number,
        required: true
      },
      bookingId: {
        type: Number
      },
      credentials: {
        type: Object,
        default: () => ({}) // Default value is an empty object
      },
      customerId:{
          type: Number,
          required: true
      },
      showViewIssuesPopup:0,
    },
    data() {
        return {
            activeTab: this.showViewIssuesPopup ? 'issues' :  'communication',
            totalIssues: 0,
            complaintId: 0,
        };
    },
  mounted() {
        // make on event bus and make on it the active tab is communications
      EventBus.$on('showDiscussions', (complaintId) => {
        this.activeTab = 'communication';
        this.complaintId = complaintId;
      })

  },
    methods:{
        showTabs(){
            if (document.getElementById('tabsDiv')){
            document.getElementById('tabsDiv').classList.remove('hidden');
            let tabsDiv = document.getElementById('tabsDiv');
            this.$nextTick(()=>{
                document.getElementById('ActivityTab').appendChild(tabsDiv)
            })
            }
        },
        hideTabs(tab='CommunicationTab'){
            if (document.getElementById('tabsDiv')){
            document.getElementById('tabsDiv').classList.add('hidden');
            let tabsDiv = document.getElementById('tabsDiv');
            this.$nextTick(()=>{
                document.getElementById(tab).appendChild(tabsDiv)
            })
            }
        }
    }
}
</script>

<style scoped>
.new-tabs{
    background-color: #FFFFFF;
}
#myTab{
    border: none;
}
#myTab a {
    background-color: #FFFFFF !important;
    border: none !important;
    color: rgba(46, 64, 81, 1) !important;
}
#myTab > li.active > a {
    border-bottom: 4px solid #2E4051 !important;
}
.tab-text{
    font-size: 15px;
}
</style>
